var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, SimpleChanges, OnDestroy } from '@angular/core';
import { ActivityService } from 'app/services/activity.service';
import { AttrIndexService } from 'app/services/attr-index.service';
// import { LayerQcService } from 'app/services/layer-qc.service';
// import { UserService } from 'app/services/user.service';
import { MainDataService } from 'app/services/main-data.service';
import { TooltipHelpService } from 'app/services/tooltip-help.service';
var QcFiltersMyLayersComponent = /** @class */ (function () {
    function QcFiltersMyLayersComponent(activityService, attrIndexService, mainDataService, tooltipHelpService) {
        this.activityService = activityService;
        this.attrIndexService = attrIndexService;
        this.mainDataService = mainDataService;
        this.tooltipHelpService = tooltipHelpService;
        this.filterOptions = [];
        this.filterOptionsAll = [];
    }
    QcFiltersMyLayersComponent.prototype.clickApply = function () {
        this.activityService.applyAttrFilterSubject.next();
        // this.activityService.refreshData.next()
    };
    QcFiltersMyLayersComponent.prototype.toggleCheckAll = function () {
        var _this = this;
        // if (!this.isQc) {
        // 	return;
        // }
        this.isCheckAll = !this.isCheckAll;
        this.filterOptionsAll.forEach(function (d) { return d.isSelected = _this.isCheckAll; });
        this.triggerQcChange();
    };
    QcFiltersMyLayersComponent.prototype.toggleFilterOption = function (option, skipGetData) {
        // Make sure only one filter is selected
        if (option.isSelected) {
            this.filterOptionsAll.forEach(function (o) {
                if (o !== option && o.isSelected) {
                    o.isSelected = false;
                }
            });
        }
        this.triggerQcChange(skipGetData);
    };
    QcFiltersMyLayersComponent.prototype.onMouseoverCode = function (option) {
        var _this = this;
        this.mouseoverCodeTimeout = setTimeout(function () {
            var codes = [option.value];
            _this.tooltipHelpService.lastTooltipsBS.next({
                codes: codes
            });
        }, this.tooltipHelpService.delayTime);
    };
    QcFiltersMyLayersComponent.prototype.onMouseoutCode = function () {
        if (this.mouseoverCodeTimeout) {
            clearTimeout(this.mouseoverCodeTimeout);
        }
    };
    QcFiltersMyLayersComponent.prototype.filterFilterOptions = function () {
        var _this = this;
        if (this.selectedLayer && this.selectedLayer.category.code === this.attrIndexService.cateCodeAddress) {
            var toRemove_1 = [];
            switch (this.modelKey) {
                case 'L':
                    this.filterOptions = this.filterOptionsAll.filter(function (i) {
                        if (i.value.startsWith('FS')) {
                            var isShow = i.value.endsWith('L');
                            if (!isShow && i.isSelected) {
                                toRemove_1.push(i);
                            }
                            return isShow;
                        }
                        return true;
                    });
                    break;
                case 'N':
                    this.filterOptions = this.filterOptionsAll.filter(function (i) {
                        if (i.value.startsWith('FS')) {
                            var isShow = !i.value.endsWith('L');
                            if (!isShow && i.isSelected) {
                                toRemove_1.push(i);
                            }
                            return isShow;
                        }
                        return true;
                    });
                    break;
                default:
                    this.filterOptions = this.filterOptionsAll;
                    break;
            }
            if (toRemove_1.length) {
                toRemove_1.forEach(function (i) {
                    i.isSelected = false;
                    _this.toggleFilterOption(i);
                });
            }
        }
        else {
            this.filterOptions = this.filterOptionsAll;
        }
    };
    QcFiltersMyLayersComponent.prototype.checkShowCheckAllBox = function () {
        this.showCheckAllBox = this.qcState.num > 1.51 && !!(this.filterOptionsAll.find(function (o) { return !!o.count; }));
    };
    QcFiltersMyLayersComponent.prototype.triggerQcChange = function (skipGetData, isQcUserPrefer) {
        this.mainDataService.qcFilterInfo.next({
            // isQcFilter: this.isQc,
            isCheckAll: this.isCheckAll,
            isQcUserPrefer: isQcUserPrefer,
            filterOptions: this.filterOptionsAll,
            skipGetData: skipGetData,
            source: 'filterTab'
        });
    };
    // runQc() {
    // 	this.clickRunQc.emit();
    // }
    QcFiltersMyLayersComponent.prototype.ngOnInit = function () {
        var _this = this;
        var isInit = true;
        this.addressCateCode = this.attrIndexService.cateCodeAddress;
        this.filterOptionsSub = this.mainDataService.qcFilterInfo.subscribe(function (data) {
            if (isInit) {
                _this.isCheckAll = data.isCheckAll;
                _this.filterOptionsAll = data.filterOptions;
            }
            else if (data.source !== 'filterTab') {
                _this.filterOptionsAll = data.filterOptions;
                if (data.hasOwnProperty('isCheckAll') && data.isCheckAll !== _this.isCheckAll) {
                    _this.toggleCheckAll();
                }
            }
            _this.filterFilterOptions();
            var selectedLayer = _this.selectedLayer;
            if (selectedLayer) {
                _this.qcState = selectedLayer.state;
                // this.qcStateText = this.attrIndexService.layerLoadStateTextMap[this.qcState];
                _this.checkShowCheckAllBox();
            }
        });
        this.modelSub = this.mainDataService.modelBS.subscribe(function (data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.modelKey !== data) {
                    this.modelKey = data;
                    this.filterFilterOptions();
                }
                return [2 /*return*/];
            });
        }); });
        this.selectedLayerSub = this.activityService.selectedLayerBS.subscribe(function (data) {
            _this.selectedLayer = _this.activityService.selectedLayerBS.getValue().layer;
        });
        isInit = false;
    };
    QcFiltersMyLayersComponent.prototype.ngOnChanges = function (changes) {
        // if (changes.myLayer && !changes.myLayer.firstChange) {
        // 	this.onLayerChange(changes.myLayer.currentValue);
        // }
    };
    QcFiltersMyLayersComponent.prototype.ngOnDestroy = function () {
        this.filterOptionsSub.unsubscribe();
        this.modelSub.unsubscribe();
        this.selectedLayerSub.unsubscribe();
    };
    return QcFiltersMyLayersComponent;
}());
export { QcFiltersMyLayersComponent };
